import { Dropdown } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import {
  SoftwarePackageDefault,
  SoftwarePackageInstallType
} from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

export interface SoftwarePackageDefaultInstallTypeDropDownProps {
  softwarePackage?: SoftwarePackageDefault;
  onUpdate: (installType: SoftwarePackageInstallType) => void;
}

export const SoftwarePackageDefaultInstallTypeDropDown = ({
  softwarePackage,
  onUpdate
}: SoftwarePackageDefaultInstallTypeDropDownProps) => {
  const { data: hasDeployPermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementDeploy
  );

  const installTypeOptions =
    Object.values(SoftwarePackageInstallType)?.map(key => {
      return { key, text: key };
    }) ?? [];

  return (
    <Dropdown
      disabled={
        !hasDeployPermission ||
        !softwarePackage ||
        !softwarePackage.softwarePackageVersionId
      }
      title={!hasDeployPermission ? NO_ACTION_PERMISSION : undefined}
      name="installType"
      selectedKey={
        softwarePackage?.installType ?? SoftwarePackageInstallType.All
      }
      options={installTypeOptions}
      withNoEmptyOption
      onChange={(_, options): void => {
        const selectedOption = options.option;
        const selectedInstallType =
          selectedOption?.key === "" || selectedOption?.key == null
            ? undefined
            : (selectedOption.key as SoftwarePackageInstallType);

        if (!!selectedInstallType) onUpdate(selectedInstallType);
      }}
    />
  );
};
